import { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Demo2Nav from './Demo2Nav';
import { useDemo2Ctx } from '../Demo2Context';
import { WEB_SIDEBAR_SECTIONS, WEB_PAGE_META } from '../demo2Routes';

export default function Demo2WebLayout() {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { toast, alerts } = useDemo2Ctx();
    const unread = alerts.filter(a => !a.read).length;

    const path = location.pathname;
    const pageKey =
        Object.keys(WEB_PAGE_META).find(k =>
            path.startsWith(`/demo2/web/${k}`),
        ) ?? 'dashboard';
    const meta = WEB_PAGE_META[pageKey] ?? { title: '', bc: ['홈'] };

    return (
        <>
            <Demo2Nav />
            <div className="sian sian-app">
                <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
                    <div className="sb-logo">
                        <div className="sb-logo-mark">
                            <i className="ri-tree-line" />
                        </div>
                        <div>
                            <div className="sb-logo-text">
                                <em>AIS</em> × 수프로
                            </div>
                            <div className="sb-logo-tag">수목관리 시스템</div>
                        </div>
                    </div>
                    <nav className="sb-nav">
                        {WEB_SIDEBAR_SECTIONS.map(sec => (
                            <div key={sec.label}>
                                <div className="sb-section-lbl">
                                    {sec.label}
                                </div>
                                {sec.items.map(it => (
                                    <div
                                        key={it.key}
                                        className={`nav-item${pageKey === it.key ? ' active' : ''}`}
                                        onClick={() => navigate(it.path)}
                                    >
                                        <i className={`nav-ico ${it.riIco}`} />
                                        <span className="nav-txt">
                                            {it.txt}
                                        </span>
                                        {it.pillFromAlerts && unread > 0 && (
                                            <span className="nav-pill">
                                                {unread}
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </nav>
                    <div className="sb-footer">
                        <div className="sb-user">
                            <div className="sb-avatar">김</div>
                            <div className="sb-user-info">
                                <div className="sb-user-name">김관리자</div>
                                <div className="sb-user-role">
                                    관리자 · AIS 스마트수목관리
                                </div>
                            </div>
                        </div>
                        <button
                            className="sb-toggle"
                            onClick={() => setCollapsed(c => !c)}
                        >
                            {collapsed ? '▶' : '◀'}
                        </button>
                    </div>
                </aside>

                <div className="main-area">
                    <header className="topbar">
                        <div>
                            <div className="topbar-title">{meta.title}</div>
                            <div className="topbar-bc">
                                {meta.bc.map((p, i) => (
                                    <span key={i}>
                                        {i > 0 && (
                                            <span className="sep"> › </span>
                                        )}
                                        <span>{p}</span>
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div className="tb-search">
                            <i className="ri-search-line tb-search-ico" />
                            <input
                                type="text"
                                className="tb-search-input"
                                placeholder="구역명, 주소, 수종 검색..."
                            />
                        </div>
                        <div className="tb-spacer" />
                        <div className="tb-actions">
                            <button
                                className="tb-icon-btn"
                                onClick={() => navigate('/demo2/web/alerts')}
                                title="알림 센터"
                            >
                                <i className="ri-notification-3-line" />
                                {unread > 0 && <span className="notif-dot" />}
                            </button>
                            <button
                                className="tb-profile"
                                onClick={() =>
                                    toast('프로필 메뉴 (데모)', 'success')
                                }
                            >
                                <div className="tb-profile-av">김</div>
                                <span className="tb-profile-name">
                                    김관리자
                                </span>
                                <span
                                    style={{
                                        fontSize: 10,
                                        color: 'var(--text3)',
                                    }}
                                >
                                    ▾
                                </span>
                            </button>
                            <button
                                className="tb-lang"
                                onClick={() =>
                                    toast('언어 설정 (데모)', 'success')
                                }
                            >
                                KO
                            </button>
                        </div>
                    </header>
                    <div className="content">
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
}
